/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const BlockLabellingPattern = {
    Numeric: 'Numeric',
    Alphabetic: 'Alphabetic',
    Custom: 'Custom',
} as const;

export type BlockLabellingPattern = typeof BlockLabellingPattern[keyof typeof BlockLabellingPattern];



